import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { MessageService, ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { DripCampaignTemplate } from '@app/_models/drip-campaign';
import { DripCampaignTemplateService } from '../drip-campaign-template.service';
import { AlertService } from '@app/_services';

@Component({
  selector: 'app-drip-campaign-template-list',
  templateUrl: './drip-campaign-template-list.component.html',
  providers: [MessageService, ConfirmationService],
  standalone: false
})
export class DripCampaignTemplateListComponent implements OnInit {

  templates: DripCampaignTemplate[] = [];
  recordTotal = 0;
  loading = true;
  lazyLoadEvent: LazyLoadEvent;
  multiSortMeta: any[] = [];

  taskSourceLabels: { [key: number]: string } = {
    4: 'Quote',
    5: 'Owner Lead',
    6: 'Owner Statement',
    7: 'Onboarding'
  };

  constructor(
    private svc: DripCampaignTemplateService,
    private router: Router,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.multiSortMeta = [{ field: 'createDate', order: -1 }];
  }

  loadLazy(event: LazyLoadEvent) {
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      if (Object.keys(event.filters || {}).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [{ field: 'createDate', order: -1 }];
      }

      const page = Math.round((event.first || 0) / (event.rows || 50));
      this.svc.findAll(page, event.rows || 50, event.sortField, event.sortOrder, event.multiSortMeta, event.globalFilter, event.filters)
        .pipe(first())
        .subscribe(
          (res: any) => {
            this.templates = res?.data?.dripCampaignTemplates ?? [];
            this.recordTotal = res?.page?.recordTotal ?? 0;
          },
          (err: any) => {
            this.alertService.error(err);
          },
          () => { this.loading = false; }
        );
    } catch (error) {
      console.error('loadLazy error', error);
      this.loading = false;
    }
  }

  onNew() {
    this.router.navigate(['/drip-campaign-template-edit']);
  }

  onEdit(t: DripCampaignTemplate) {
    this.router.navigate(['/drip-campaign-template-edit', t.dripCampaignTemplateId]);
  }

  onDelete(t: DripCampaignTemplate) {
    this.confirmationService.confirm({
      message: 'Delete template "' + t.name + '"? This cannot be undone.',
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.svc.delete(t.dripCampaignTemplateId).pipe(first()).subscribe(
          () => {
            this.templates = this.templates.filter(x => x.dripCampaignTemplateId !== t.dripCampaignTemplateId);
            this.recordTotal = Math.max(0, this.recordTotal - 1);
            this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Template removed', life: 3000 });
          },
          (err: any) => this.alertService.error(err)
        );
      }
    });
  }

  getTaskSourceLabel(val: number): string {
    return val != null ? (this.taskSourceLabels[val] || 'Any') : 'Any';
  }
}
